import React, { Component } from 'react';
import {connect} from 'react-redux';
import {updateSearchCondition} from '../../actions';


import Pagination from '../../components/pagination';

const NAVSIZE = 10;

class PageContainer extends Component {

  handlePageChange(pageNumber) {
    const { handlePageChange, searchCondition, handleActivePage} = this.props;
    handlePageChange((pageNumber-1) * searchCondition.pageSize);
    // this.setState({activePage: pageNumber});
    handleActivePage(pageNumber);
  }

  // initActivePage(){
  //   this.setState({activePage: 1});
  // }


  render() {
    const {
      pageFrom,
      activePage
    } = this.props;
    const {
      pageSize,
      totalCount
    } = this.props.searchCondition;
    // const {
    //   activePage
    // } = this.state;

    return (
      <div className="page-container">
        <Pagination
          activePage={activePage}
          beginIndex={pageFrom}
          count={10}
          itemsCountPerPage={pageSize}
          totalCount={totalCount}
          pageRangeDisplayed={NAVSIZE}
          handlePageChange={this.handlePageChange.bind(this)}
        />
        <div className="list-total"><span>{`${totalCount} 건`}</span></div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    searchCondition: state.searchCondition
  }
};


PageContainer = connect(mapStateToProps)(PageContainer);


export default PageContainer;


// WEBPACK FOOTER //
// ./src/containers/search/PageContainer.js